import { render } from "./BaseSelectListLocation.vue?vue&type=template&id=31aca796"
import script from "./BaseSelectListLocation.vue?vue&type=script&lang=js"
export * from "./BaseSelectListLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__